var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCommentPinned = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none",
    viewBox: "0 0 10 10",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "#FD0",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    x: 0.5,
    y: 0.5,
    stroke: "#222",
    strokeOpacity: 0.05,
    rx: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "m5 2 .674 2.073h2.18L6.09 5.354l.673 2.073L5 6.146 3.237 7.427l.673-2.073-1.763-1.281h2.18z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCommentPinned);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/comment_pinned.9b412a9337a3ee3254e2cd331901d368.svg";